<script setup lang="ts">
import { useDisciplinePaymentLinksStore } from '../model/payment-links/store'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplinePaymentLinks from './DisciplinePaymentLinks.vue'

defineOptions({
  name: 'DisciplineOrdersCreatePage',
})

const paymentLinksStore = useDisciplinePaymentLinksStore()
</script>

<template>
  <DisciplinePageLoader :loading="paymentLinksStore.isLoading" />
  <DisciplinePaymentLinks />
</template>
